import { reportsService } from '@/services';
import { downloadBlob } from '@/shared/utils/download-blob.util';
import { useMutation } from '@tanstack/react-query';

interface PrintStatementParams {
  /** 1 = Assessoria, 2 = Corretor (só Seguradora; scoped resolve no backend). */
  beneficiaryType?: number;
  advisoryPartyCode?: string;
  brokerPartyCode?: string;
  dateFrom: string;
  dateTo: string;
}

/**
 * Imprime o Demonstrativo de Comissão (PDF base64 → blob → download) via erpws
 * `ImprimirRecibo` (modo período). Espelha o fluxo do boleto/recibo.
 */
export function useCommissionStatementPrint() {
  return useMutation({
    retry: false,
    mutationFn: async (params: PrintStatementParams) => {
      const result = await reportsService.printCommissionStatement(params);
      if (!result.success || !result.data?.pdfBase64) {
        throw new Error(
          result.error ||
            'Nenhum demonstrativo de comissão foi encontrado para os critérios informados.'
        );
      }

      const byteChars = atob(result.data.pdfBase64);
      const bytes = new Uint8Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        bytes[i] = byteChars.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: 'application/pdf' });
      downloadBlob(
        blob,
        `demonstrativo-comissao-${params.dateFrom}_${params.dateTo}.pdf`
      );
    },
  });
}
